import { styled } from 'styled-components'

import {
  getSellerCollectsConfig,
  type OrchestratedCommonListingDetails,
} from '@b-stock/fe-core/bstock-next/queries'
import { Banner, FormattedMessage } from '@b-stock/fe-core/bstock-react'

import { bStockQuotesShipping } from '@/buyer-portal/components/features/listing/actions/auction/BidFormProvider/BidConfirmationModal/sellerCollectsBidCopy'
import { useIsSellerCollectsSale } from '@/buyer-portal/helpers/useIsSellerCollectsSale'

const ns = 'Listing.confirmationModal.info'

const InfoBannerContainer = styled.div`
  padding-top: 1.5rem;
`

const InfoList = styled.ul`
  padding: 0;
`

export const InfoBanner = ({
  listing,
}: {
  listing: OrchestratedCommonListingDetails
}) => {
  const isContract = listing.listingType === 'CONTRACT'
  const isOffering = listing.pricingStrategy === 'MAKE_AN_OFFER'

  // B-Stock's own shipping-rate estimate and its driver's unload allowance
  // are only true when B-Stock itself quotes and books the freight; every
  // other Seller Collects arrangement settles shipping off-platform. Same
  // rule BuyNowConfirmationModal/BidConfirmationModal apply via
  // `bStockQuotesShipping` — this banner must not disagree with them.
  const isSellerCollectsSale = useIsSellerCollectsSale(listing)
  const sellerCollectsConfig = getSellerCollectsConfig(listing)
  const showShippingNotice =
    !isSellerCollectsSale || bStockQuotesShipping(sellerCollectsConfig)

  const showEstimatedShippingFee = !isContract && showShippingNotice
  const showUnloadLimits = showShippingNotice

  if (!isOffering && !showEstimatedShippingFee && !showUnloadLimits) {
    return null
  }

  return (
    <InfoBannerContainer>
      <Banner title={<FormattedMessage id={`${ns}.title`} />}>
        <InfoList>
          {isOffering && (
            <li>
              <FormattedMessage id={`${ns}.offeringDecisionTime`} />
            </li>
          )}
          {showEstimatedShippingFee && (
            <li>
              <FormattedMessage id={`${ns}.estimatedShippingFee`} />
            </li>
          )}
          {showUnloadLimits && (
            <li>
              <FormattedMessage id={`${ns}.unloadLimits`} />
            </li>
          )}
        </InfoList>
      </Banner>
    </InfoBannerContainer>
  )
}
